import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 2,
    name: 'chairmanName',
    type: 'text',
    label: 'Name of Chairman',
  },
  {
    colSpan: 1,
    name: 'chairmanOfficeTelephone',
    type: 'text',
    label: 'Office Telephone',
  },
  {
    colSpan: 1,
    name: 'chairmanResidenceTelephone',
    type: 'text',
    label: 'Residence Telephone',
  },
  {
    colSpan: 1,
    name: 'chairmanMobileNo',
    type: 'text',
    label: 'Mobile Number',
  },
  {
    colSpan: 1,
    name: 'chairmanEmail',
    type: 'email',
    label: 'Email Address',
  },
];

export const chairmanInfoFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].label).nullable(),
  [fields[1].name]: yup.string().label(fields[1].label).nullable(),
  [fields[2].name]: yup.string().label(fields[2].label).nullable(),
  [fields[3].name]: yup.string().label(fields[3].label).nullable(),
  [fields[4].name]: yup.string().email().label(fields[4].label).nullable(),
};

const ChairmanInformationSection = (props) => {
  return (
    <FormSection
      sectionName="Chairman Information"
      sectionColumn={2}
      formFields={fields}
      {...props}
    />
  );
};

export default ChairmanInformationSection;
